import { Injectable, Injector } from '@angular/core';
import { EMPTY, from, of } from 'rxjs';
import { concatMap, map, switchMap, takeLast, tap } from 'rxjs/operators';
import { BefRepository } from '@farris/bef';
import { FrameContext, DataPathCreator, Repository, DataPath, EntityList, BindingList, Entity, BindingObject } from '@farris/devkit';
import { LanguageService } from './languag.service';
import { FormMessageService } from './form-message.service';

@Injectable()
export class PopUpService {
  private cache: Map<string, any> = new Map<string, any>();
  constructor(
    private injector: Injector,
    private frameContext: FrameContext,
    private repository: Repository<any>,
    private languageService: LanguageService,
    private messageService: FormMessageService
  ) { }
  public confirm() { }
  /**
   * åæ¶åæ´
   * @param frameId
   * @param id
   * @returns
   * @throws invalid frameid
   */
  public cancel(frameId: string, id?: string) {
    const frameContext = this.frameContext.appContext.frameContextManager.getFrameContextById(frameId);
    if (!frameContext) {
      throw new Error(`[PopUpService]Invalid frameId ${frameId}`);
    }
    const primaryValue = this.frameContext.bindingData.list.currentId;
    const bindingPath = frameContext.viewModel.bindingPath;
    const bindingPaths = bindingPath.split('/').filter((p) => p);
    if (!id) {
      const bindingList = this.frameContext.bindingData.getList() as BindingList;
      id = bindingList.currentId;
    }
    const befRepository = this.repository as BefRepository<any>;
    const longPaths = (DataPathCreator.createByShortPathFromRoot(bindingPaths, befRepository.entityManager, this.frameContext.bindingData) as DataPath).toArray().map((path: string) => path.split(':')[1]);
    const entityListPaths = Array.from(longPaths);
    // èå¼å½åè¡¨å½åè¡
    entityListPaths.pop();
    const dialogRef = this.frameContext.frameComponent['dialogRef'];
    if (entityListPaths.length < 1) {
      // ä¸»è¡¨
      const entity = this.repository.entityCollection.getEntityById(id) as Entity;
      const originalData = entity['originalData'];
      entity.load(originalData, { loadChild: false });
    } else {
      const entityList = befRepository.entityManager.getEntityNodeByPath(entityListPaths) as EntityList<any>;
      if (entityList) {
        const originalData: any[] = entityList['originalData'];
        const item = originalData.find((item) => item.id === id);
        if (item) {
          // å·²ææ°æ®ï¼è¿ååæ´
          const entity: Entity = befRepository.entityManager.getEntityByPath(longPaths) as Entity;
          if (entity.changes && entity.changes.length > 0) {
            return this.messageService.confirm(this.languageService.cancelWithoutSave).pipe(
              tap((result: boolean) => {
                if (result) {
                  entity.load(item, { loadChild: false });
                  entity.changes.splice(0, entity.changes.length);
                }
              })
            );
          } else {
            // æ²¡æä¿®æ¹ï¼ç´æ¥å³é­
            if (dialogRef) {
              dialogRef.close();
            }
          }
        } else {
          // æ°å¢çæ°æ®ï¼å é¤
          const paths = this.buildPath(bindingPath, primaryValue);
          return this.messageService.confirm(this.languageService.cancelWithoutSave).pipe(
            switchMap((result) => {
              if (result) {
                return befRepository.removeEntityByPath(paths, id).pipe(
                  tap(() => {
                    befRepository.entityManager.removeEntityByPath(paths, id);

                    if (entityList.count() === 0 && dialogRef) {
                      dialogRef.close();
                    }
                  })
                );
              } else {
                return EMPTY;
              }
            })
          );
        }
      }
    }
    return of([]);
  }
  /**
   * åæ­¥å½åè¡
   * @param id å½åè¡
   */
  public updateCurrentRow(id?: string) {
    this.frameContext.frameComponent.isRootLayout = true;
    const bindingPath = this.frameContext.viewModel.bindingPath;
    const bindingPaths = bindingPath.split('/').filter((p) => p);
    // const frameId = this.frameContext.frameId;
    const root = this.frameContext.getVirtualRootFrameContext();
    const primaryKeyValue = root.bindingData.list.currentId;
    this.frameContext.bindingData.list.setCurrentId(primaryKeyValue);
    if (bindingPaths.length > 0) {
      const paths = [];
      bindingPaths.forEach((path: string, index: number, array) => {
        paths.push(path);
        const bindingList = root.bindingData.getValue(paths) as BindingList;
        if (bindingList) {
          const currentId = bindingList.currentId;
          const modalBindingList = this.frameContext.bindingData.getValue(paths) as BindingList;
          if (index === bindingPath.length - 1 && id) {
            modalBindingList.setCurrentId(id, true, true);
          } else if (modalBindingList) {
            modalBindingList.setCurrentId(currentId, true, true);
          }
        }
      });
    }
  }
  public closeCheck() {
    const frameContext = this.frameContext;
    const bindingPath = frameContext.viewModel.bindingPath;
    const bindingPaths = bindingPath.split('/').filter((p) => p);
    const befRepository = this.repository as BefRepository<any>;
    const longPaths = (DataPathCreator.createByShortPathFromRoot(bindingPaths, befRepository.entityManager, this.frameContext.bindingData) as DataPath).toArray().map((path: string) => path.split(':')[1]);
    const entityListPaths = Array.from(longPaths);
    entityListPaths.pop();
    const entityList = befRepository.entityManager.getEntityNodeByPath(entityListPaths) as EntityList<any>;
    const dialogRef = this.frameContext.frameComponent['dialogRef'];
    if (entityList.count() === 0 && dialogRef) {
      dialogRef.close();
    }
  }
  /**
   * å é¤å¼¹çªä¸­çå½åè¡æ°æ®
   * @param frameId -å¯éï¼è¦å é¤æ°æ®æå¨ç»ä»¶çidï¼é»è®¤ä¸ºå½ä»¤æå¨çç»ä»¶
   * @param id -å¯éï¼è¦å é¤æ°æ®çidï¼é»è®¤ä¸ºå½ä»¤æå¨ç»ä»¶çå½åè¡æ°æ®id
   * @param showConfirm -å¯éï¼å é¤æ°æ®æ¶æ¯å¦è¿è¡å é¤åçç¡®è®¤ï¼é»è®¤ä¸º`true`
   * @returns
   * @throws ç»ä»¶idéè¯¯æ¶æåºéè¯¯
   */
  public removeRow(frameId?: string, id?: string, showConfirm: string | boolean = true) {
    const frameContext = frameId ? this.frameContext.appContext.frameContextManager.getFrameContextById(frameId) : this.frameContext;
    if (!frameContext) {
      throw new Error(`æ æçç»ä»¶idï¼${frameId}`);
    }
    // çº æ­£ä¸»é®
    if (!id) {
      const bindingList = frameContext.bindingData.getList() as BindingList;
      id = bindingList.currentId;
    }
    const bindingPath = frameContext.viewModel.bindingPath;
    const bindingPaths = bindingPath.split('/').filter((p) => p);
    const paths = this.buildPath(bindingPath, this.frameContext.bindingData.list.currentId);
    const befRepository = this.repository as BefRepository<any>;
    // è½¬æ¢showConfirmä¸ºå¸å°
    if (typeof showConfirm == 'string') {
      showConfirm = showConfirm.trim() === 'false' ? false : true;
    }
    let confirm$ = of(true);
    if (showConfirm) {
      confirm$ = this.messageService.confirm(this.languageService.confirmDeletion);
    }
    return confirm$.pipe(
      switchMap((result) => {
        if (result) {
          if (bindingPaths.length === 0) {
            // ä¸»è¡¨å é¤ï¼ä¸ç«å³ä¿å­
            return befRepository.removeEntityById(id, false);
          } else {
            return befRepository.removeEntityByPath(paths, id).pipe(
              tap(() => {
                befRepository.entityManager.removeEntityByPath(paths, id);
              })
            );
          }
        } else {
          return EMPTY;
        }
      })
    );
  }
  /**
   * å³é­å¼¹çª
   * @param frameId -å¯éï¼ç»ä»¶idï¼ä¸æå®æ¶ä½¿ç¨å½ä»¤æå¨çä¸ä¸æç»ä»¶
   * @throws ä½¿ç¨æå®çç»ä»¶idæ æ³è·åç»ä»¶åå¼¹çªç»ä»¶å®ä¾è·åå¤±è´¥æ¶ä¼æåºå¼å¸¸
   */
  public closeDialog(frameId?: string) {
    let frameContext = this.frameContext;
    let dialogRef = null;
    // å¼åèæå®äºç»ä»¶id
    if (frameId) {
      frameContext = this.frameContext.appContext.frameContextManager.getFrameContextById(frameId);
      if (!frameContext) {
        throw new Error('æå®äºæ æçç»ä»¶id');
      }
      dialogRef = frameContext.frameComponent['dialogRef'];
    } else {
      // å°è¯ä»å½åç»ä»¶ä¸ä¸æä¸­è·åå¼¹çªå¼ç¨
      dialogRef = frameContext.frameComponent['dialogRef'];
      if (!dialogRef) {
        // å¦æå½ä»¤æè½½å°äºåå®¹ç»ä»¶ä¸
        dialogRef = this.frameContext.parent.frameComponent['dialogRef'];
      }
    }
    if (!dialogRef) {
      throw new Error(`æ æ³è·åå¼¹çªç»ä»¶å®ä¾`);
    }
    dialogRef.close();
  }
  /**
   * è¿åèªä¸æ¬¡æä¹åä»¥åäº§ççåæ´
   * @param frameId - ç»ä»¶id
   * @param id - æ°æ®id
   * @param showConfirm - æ¯å¦å±ç¤ºæç¤ºä¿¡æ¯
   */
  public cancelChanges(frameId?: string, id?: string, showConfirm: boolean | string = true) {
    const frameContext = this.getFrameContext(frameId);
    // çº æ­£ä¸»é®
    id = this.getPrimaryValue(frameId, id);
    const data = this.getPersisteData(frameId, id);
    if (typeof showConfirm === 'string') {
      showConfirm = showConfirm.trim().toLowerCase() === 'false' ? false : true;
    }
    const isDataChanged = this.isDataChanged(data, frameId, id);
    let result$ = of(true);
    if (showConfirm && isDataChanged) {
      result$ = this.messageService.confirm(this.languageService.cancelWithoutSave);
    }
    return result$.pipe(
      switchMap((result: boolean) => {
        if (result) {
          const befRepository = frameContext.repository as BefRepository<any>;
          const bindingPaths = frameContext.viewModel.bindingPath.split('/').filter((p) => p);
          const frameContexts = frameContext.appContext.frameContextManager.getFrameContexts();
          // è·åå°ææçç»å®è·¯å¾ï¼pathséé¢ä¼å­å¨éå¤çè³éè¯¯çè·¯å¾
          const paths = frameContexts.map((frameContext: FrameContext) => frameContext.viewModel.bindingPath);
          const bindingPath = frameContext.viewModel.bindingPath;
          // æ¾å°ææä¸çº§ç»å®è·¯å¾
          let childrenBindingPaths = paths.filter((path: string) => path.startsWith(bindingPath) && path.length > bindingPath.length);
          // å»é
          childrenBindingPaths = childrenBindingPaths.filter((item, index) => childrenBindingPaths.indexOf(item) === index);
          // éåè·¯å¾å¹¶è·åæ°æ®ï¼ç¶åä¸ç¼å­å¯¹æ¯ï¼å¤ä½çæ°æ®å é¤ã
          let task$ = of(true);
          // å¡çä¸­å­å¨ä¸çº§
          if (childrenBindingPaths && childrenBindingPaths.length > 0) {
            task$ = from(childrenBindingPaths).pipe(
              // æ°ç»å+å»ç©º
              map((bindingPath) => bindingPath.split('/').filter((item: string) => item)),
              concatMap((bindingPaths: string[]) => {
                // è·åå°å¯¹åºä»ä»è¡¨çé¢æ°æ®
                const bindingList: BindingList = frameContext.bindingData.getValue(bindingPaths);
                let primaryKey = 'id';
                let bindingListIds = [];
                if (bindingList && bindingList.length > 0) {
                  bindingListIds = bindingList.toArray().map((bindingObject: BindingObject) => bindingObject.primaryKeyValue);
                  primaryKey = bindingList.primaryKey;
                }
                // è·åå°ç¼å­æ°æ®
                const cache = this.getPersisteData(frameId, id) || {};
                // ç¼å­æ°æ®ä¸ºä»è¡¨æ°æ®ï¼ä¸çº§ä¸å®æ¯ä»ä»è¡¨ï¼ä»æ¯æå°ä»ä»è¡¨
                const cachedList: any[] = cache[bindingPaths[1]] || [];
                const cachedIds = cachedList.map((item: any) => item[primaryKey]);
                // éåå½åæ°æ®ï¼ç§»é¤æç¼å­ä¸­ä¸å­å¨çæ°æ®ï¼å é¤æ°å¢çä»ä»è¡¨æ°æ®ï¼
                const removeIds = bindingListIds.filter((id: string) => cachedIds.indexOf(id) === -1);
                // å é¤ç¼å­ä¸­å­å¨ï¼ä½çé¢ä¸ä¸å­å¨çç¼å­é¡¹
                const ids = cachedIds.filter((id: string) => {
                  return bindingListIds.indexOf(id) === -1;
                });
                if (ids && ids.length > 0) {
                  ids.forEach((id: string) => {
                    const index = cachedList.findIndex((item: any) => item[primaryKey] === id);
                    cachedList.splice(index, 1);
                  });
                }
                let remove$ = of(true);
                if (removeIds && removeIds.length > 0) {
                  // è¿åbindingPath
                  const bindingPath = '/' + bindingPaths.join('/');
                  const id = this.frameContext.bindingData.list.currentId;
                  const path = this.buildPath(bindingPath, id);
                  remove$ = this.repository.batchRemoveByPath(path, removeIds.join(','));
                }
                return remove$;
              })
            );
          }
          return task$.pipe(
            takeLast(1),
            switchMap(() => {
              const longPaths = (DataPathCreator.createByShortPathFromRoot(bindingPaths, befRepository.entityManager, this.frameContext.bindingData) as DataPath).toArray().map((path: string) => path.split(':')[1]);
              const entityPaths = Array.from(longPaths);
              const entity = befRepository.entityManager.getEntityNodeByPath(entityPaths) as Entity;
              if (entity) {
                // è¿åæ°æ®æ¶ä»å è½½å½åå®ä½çï¼ä¸çº§è¡¨ä¸éæ°å è½½
                entity.load(data);
              }
              return of(true);
            })
          );
        } else {
          return EMPTY;
        }
      })
    );
  }
  /**
   * æä¹åæ°æ®
   * @param frameId - ç»ä»¶id
   * @param id - æ°æ®id
   */
  public persiste(frameId?: string, id?: string) {
    // æä¹åæ°æ®
    const bindingObject = this.getBindingObject(frameId, id);
    const primaryValue = bindingObject.primaryKeyValue;
    // ä¸æ¯æå­è¡¨å¼¹åºç¼è¾ååæ¬¡å¼¹åºç¼è¾ï¼è®¾è®¡å¨å·²ç¦ç¨ï¼
    this.cache.clear();
    this.cache.set(primaryValue, bindingObject.toJSON({ useFullMultiLangProperty: true }));
  }
  /**
   * è·åæä¹åæ°æ®
   * @param frameId - ç»ä»¶id
   * @param id - æ°æ®id
   * @returns
   */
  private getPersisteData(frameId?: string, id?: string) {
    const bindingObject = this.getBindingObject(frameId, id);
    const primaryValue = bindingObject.primaryKeyValue;
    return this.cache.get(primaryValue);
  }
  private isDataChanged(data: { [prop: string]: any; }, frameId?: string, id?: string) {
    const bindingObject = this.getBindingObject(frameId, id);
    const value = bindingObject.toJSON({ useFullMultiLangProperty: true });
    return JSON.stringify(value) !== JSON.stringify(data);
  }
  /**
   * è·åå½åè¡
   * @param frameId - ç»ä»¶id
   * @param id - æ°æ®id
   * @returns
   * @throws æ¾ä¸å°å¯¹åºæ°æ®æ¶æåºæ æ³æ¾å°å¯¹åºæ°æ®çå¼å¸¸
   */
  private getBindingObject(frameId?: string, id?: string) {
    const frameContext = this.getFrameContext(frameId);
    // çº æ­£ä¸»é®
    id = this.getPrimaryValue(frameId, id);
    const bindingPaths = frameContext.viewModel.bindingPath.split('/').filter((p) => p);
    // æ¿å°å½åè¡
    const bindingList: BindingList = frameContext.bindingData.getValue(bindingPaths) as BindingList;
    if (!bindingList || bindingList.length < 1) {
      throw new Error(`æ æ³æ¾å°idä¸º:${id}çæ°æ®`);
    }
    return bindingList.currentItem;
  }
  /**
   * æé å­è¡¨è·¯å¾
   * @param bindingPath - ç»å®è·¯å¾
   * @param id - id
   * @throws å­è¡¨è·¯å¾éè¯¯
   */
  private buildPath(bindingPath: string, id: any) {
    let path = '/' + id;
    const subPaths = bindingPath.split('/');
    if (subPaths.length > 0) {
      // eg:bindingPathå½¢å¦/edus/grades,splitåæ¯['', 'edus', 'grades']
      // å æ­¤indexä»1å¼å§
      for (let index = 1; index < subPaths.length - 1; index++) {
        const subPath = subPaths[index];
        const subData = this.frameContext.viewModel.bindingData[subPath];
        if (!subData || !subData.currentId) {
          throw Error(`è·åå­è¡¨å®æ´è·¯å¾åºéï¼æ¾ä¸å°${subData}å¯¹åºçå­è¡¨ï¼æå¯¹åºå­è¡¨æ²¡æå½åè¡ã`);
        }
        path += `/${subPath}/${subData.currentId}`;
      }
    }
    path += '/' + subPaths[subPaths.length - 1];
    return path;
  }
  /**
   * æ ¹æ®ç»ä»¶idè·åç»ä»¶ä¸ä¸æ
   * @param frameId - ç»ä»¶id
   * @returns
   * @throws æ æçç»ä»¶id
   */
  private getFrameContext(frameId?: string) {
    const frameContext = frameId ? this.frameContext.appContext.frameContextManager.getFrameContextById(frameId) : this.frameContext;
    if (!frameContext) {
      throw new Error(`æ æçç»ä»¶idï¼${frameId}`);
    }
    return frameContext;
  }
  /**
   * è·åä¸»é®
   * @param frameId - ç»ä»¶id
   * @param id - æ°æ®id
   * @returns
   * @throws ç»ä»¶idæ ææ¶æåºå¼å¸¸
   */
  private getPrimaryValue(frameId?: string, id?: string) {
    if (!id) {
      const frameContext = this.getFrameContext(frameId);
      if (!frameContext) {
        throw new Error(`æ æçç»ä»¶idï¼${frameId}`);
      }
      const bindingList = frameContext.bindingData.getList() as BindingList;
      if (!bindingList || bindingList.length < 1) {
        throw new Error(`æ æçä¸»é®:${id}`);
      }
      id = bindingList.currentId;
    }
    return id;
  }
}
